export const pstHost = {
  prodI18n: 'mistfallhunter.com',
  prodCN: 'wylr.nvsgames.cn',
  devI18n: atob('b2FzaXMtYWN0LW15LmJ5dGVpbnRsLm5ldA=='),
  devCN: atob('b2FzaXMtYWN0LmJ5dGVkYW5jZS5uZXQ='),
};

const cnHost = 'wylr.nvsgames.cn';
const i18nHost = 'mistfallhunter.com';

export const isProduction = [cnHost, i18nHost].includes(window.location.hostname);
export const isPrerelease = isProduction && window.location.search.includes('env=ppe');
export const isSkystone = window.location.host.includes('skystone');

